import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NickyButtonComponent } from '../../form/nicky-button/nicky-button.component';
import { report } from 'process';

@Component({
  selector: 'app-confirm-payment-report-with-error-modal',
  imports: [MatDialogModule, TranslateModule, FormsModule, CommonModule, NickyButtonComponent],
  templateUrl: './confirm-payment-report-with-error-modal.component.html',
})
export class ConfirmPaymentReportWithErrorModalComponent {
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);
  protected translate = inject(TranslateService);

  getAwareText() {
    if (!this.data.transactionChecks.wasSentToExpectedReceiver) {
      return this.translate.instant('reportMismatchConfirmationDifferentAddress', {
        receiverAddress: this.data.receiverAddress,
      });
    }
    const reportedAsset = this.data.transactionChecks?.usedAsset;
    const expectedAsset = this.data.transactionChecks.expectedAsset;

    if (!reportedAsset) {
      return this.translate.instant('theTranscationYouReportedWasMadeUsingAdifferentAssetUndefined');
    }
    return this.translate.instant('theTranscationYouReportedWasMadeUsingAdifferentAsset', {
      reportedAsset,
      expectedAsset,
    });
  }
}
